import React from "react";

const TrendingDestinations = () => {
  return (
    <section className="trending-destinations section-padding fix">
      <div className="container">
        <div className="section-title-area lg-center">
          <div className="section-title">
            <span className="wow fadeInUp">Trending Destinations</span>
            <h2 className="wow fadeInUp" data-wow-delay=".3s">
              Trendy Travel Locations
            </h2>
          </div>
          <a
            href="/destination"
            className="theme-btn theme-btn-2 wow fadeInUp"
            data-wow-delay=".5s"
          >
            <span>Explore More</span>{" "}
            <i className="far fa-long-arrow-right"></i>
          </a>
        </div>

        <div className="row">
          {[
            { img: "01.jpg", name: "Istanbul, Turkey" },
            { img: "02.jpg", name: "Kyoto, Japan" },
            { img: "03.jpg", name: "Cusco, Peru" },
            { img: "04.jpg", name: "Vienna, Australia" },
            { img: "05.jpg", name: "Lisbon, Portugal" },
            { img: "06.jpg", name: "Zagreb, Croatia" },
          ].map((item, index) => (
            <div
              key={index}
              className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay={`.${3 + index * 2}s`}
            >
              <div className="trending-destinations-card-items">
                <div className="destinations-img">
                  <img
                    src={`/img/destinations/${item.img}`}
                    alt={item.name}
                  />
                  <div className="icon">
                    <a href="/destination-details">
                      <i className="fas fa-arrow-right"></i>
                    </a>
                  </div>
                  <ul className="destinations-content">
                    <li className="title">
                      <a href="/destination-details">{item.name}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrendingDestinations;